// mutations
import { CUSTOMER_CREATE_UPDATE_MUTATION, CUSTOMER_UPDATE_STATUS, CUSTOMER_DELETE } from '@/graphql/mutations/ClientMutation'

// Querys
import { GET_WITH_PAGINATION, GET_SUMMARY, GET_BY_ID } from '@/graphql/query/CustomerQuery'

// models
import { ClientModel, ResponseWithPagination, CustomersSummary } from '@/models'

// apollo
import { apolloClient } from '@/apollo'

class ClientService {
    async save (form: ClientModel) {
        const result = await apolloClient.mutate({
            mutation: CUSTOMER_CREATE_UPDATE_MUTATION,
            variables: {
                input: form
            }
        })
        if (result.data?.customer?.errors) {
            return {
                success: false,
                errors: result.data.customer.errors
            }
        }
        return {
            success: true,
            errors: []
        }
    }

    async changeStatus (id: number, status: boolean) {
        const result = await apolloClient.mutate({
            mutation: CUSTOMER_UPDATE_STATUS,
            variables: {
                id: id,
                status: status
            }
        })
        if (result.data?.chageStatusCustomer?.ok) {
            return {
                success: true,
                errors: []
            }
        } else {
            return {
                success: false,
                errors: 'Error al ejecuar la operación'
            }
        }
    }

    async delete (id: number) {
        const result = await apolloClient.mutate({
            mutation: CUSTOMER_DELETE,
            variables: {
                id: id
            }
        })

        if (result.data?.deleteCustomer?.ok) {
            return {
                success: true,
                errors: []
            }
        } else {
            return {
                success: false,
                errors: 'Error al ejecuar la operación'
            }
        }
    }

    async getWithPagination (perPage = 10, page = 1): Promise<ResponseWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const data: ResponseWithPagination = result.data.customersWithPagination
        return data
    }

    async getSummary (): Promise<CustomersSummary> {
        const result = await apolloClient.query({
            query: GET_SUMMARY
        })
        const data: CustomersSummary = result.data.customersSummary
        return data
    }

    async getById (id: number): Promise<ClientModel> {
        const result = await apolloClient.query({
            query: GET_BY_ID,
            variables: {
                customerId: id
            }
        })
        return result.data.customer
    }
}

export default new ClientService()
